export const getPageRange = (
  currentPageIndex: number,
  pageSize: number,
  totalRecords: number,
) => {
  if (totalRecords === 0) {
    return { lowerBound: 0, upperBound: 0 };
  }

  const firstItemIndex = currentPageIndex * pageSize;
  const lastItemIndex = firstItemIndex + pageSize;

  const lowerBound = firstItemIndex + 1;
  const upperBound = Math.min(lastItemIndex, totalRecords);

  return { lowerBound, upperBound };
};
